/*
  NDZ (07/10/2026): strumenti della ricetta (sections/noodz-ricetta-pagina.liquid e sections/ndz-ricetta-info.liquid).
  - Dosi ×1/×2/×3: in ogni riga degli ingredienti (e nelle porzioni, [data-scala]) moltiplica il numero o
    l'intervallo «1-1,5» con cui la riga comincia, e mette al plurale la parola che segue quando serve
    (1 bustina → 3 bustine, 1 uovo → 2 uova). Le righe senza numero restano come sono.
  - Modalità cucina: chiede al browser di tenere acceso lo schermo (Wake Lock); il pulsante compare solo dove il
    browser lo permette; al ritorno sulla pagina si richiede da solo.
  - Stampa: [data-stampa-ricetta] stampa solo la scheda (classe ndz-stampa-ricetta su <html>, vedi @media print);
    [data-stampa] stampa la pagina.
*/
(function () {
  var barra = document.querySelector('[data-ricetta-strumenti]');
  if (!barra) return;

  /* ---------- Dosi ----------
     Contatore «Per [−] 2 uova [+]» (sections/noodz-ricetta-pagina.liquid): la base è il numero all'inizio delle
     porzioni; ogni riga degli ingredienti (e le porzioni, [data-scala]) che comincia con un numero, o con un
     intervallo «90-100», si moltiplica per n/base. Plurale e singolare della parola dopo il numero (1 bustina →
     3 bustine, 2 uova → 1 uovo). Le righe senza numero restano come sono.
     Funzionano ancora i vecchi pulsanti ×1/×2/×3 ([data-dose]) delle ricette col modello vecchio. */
  var PLURALI = {
    bustina: 'bustine', busta: 'buste', uovo: 'uova', cucchiaio: 'cucchiai', cucchiaino: 'cucchiaini',
    fetta: 'fette', foglio: 'fogli', spicchio: 'spicchi', pezzo: 'pezzi', ciotola: 'ciotole', porzione: 'porzioni',
    persona: 'persone', rotolo: 'rotoli', pizzico: 'pizzichi', bicchiere: 'bicchieri',
    cipollotto: 'cipollotti', manciata: 'manciate',
    egg: 'eggs', sachet: 'sachets', slice: 'slices', clove: 'cloves', serving: 'servings', person: 'people', bowl: 'bowls'
  };
  var SINGOLARI = {};
  Object.keys(PLURALI).forEach(function (k) { SINGOLARI[PLURALI[k]] = k; });
  function numero(s) { return parseFloat(String(s).replace(',', '.')); }
  function scrivi(n) { return String(Math.round(n * 100) / 100).replace('.', ','); }
  function parola(resto, valore) {
    return resto.replace(/^([A-Za-zÀ-ÿ]+)/, function (p) {
      var m = p.toLowerCase();
      if (valore > 1 && PLURALI[m]) return PLURALI[m];
      if (valore <= 1 && SINGOLARI[m]) return SINGOLARI[m];
      return p;
    });
  }
  var righe = [];
  document.querySelectorAll('[data-ingredienti] li, [data-scala]').forEach(function (el) {
    var nodo = el.firstChild;
    while (nodo && nodo.nodeType !== 3) nodo = nodo.firstChild;
    if (!nodo) return;
    var m = nodo.nodeValue.match(/^(\s*)(\d+(?:[.,]\d+)?)(\s*-\s*(\d+(?:[.,]\d+)?))?(\s+)?/);
    if (!m) return;
    righe.push({ nodo: nodo, orig: nodo.nodeValue, prima: m[1], a: m[2], b: m[4], spazio: m[5] || '', resto: nodo.nodeValue.slice(m[0].length) });
  });
  function scala(f) {
    righe.forEach(function (r) {
      if (f === 1) { r.nodo.nodeValue = r.orig; return; }
      var a = numero(r.a) * f;
      var t = r.prima + scrivi(a);
      if (r.b) t += '-' + scrivi(numero(r.b) * f);
      r.nodo.nodeValue = t + r.spazio + parola(r.resto, r.b ? 2 : a);
    });
  }
  /* contatore per persone / uova / ciotole */
  var dosi = document.querySelector('[data-dosi]');
  if (dosi) {
    var base = Number(dosi.dataset.base) || 1;
    var n = base;
    var out = dosi.querySelector('[data-dosi-n]');
    var unita = dosi.querySelector('[data-dosi-unita]');
    var unitaOrig = unita ? unita.textContent : '';
    var meno = dosi.querySelector('[data-dosi-meno]');
    var aggiorna = function () {
      out.textContent = n;
      if (unita) unita.textContent = parola(unitaOrig, n);
      meno.disabled = n <= 1;
      scala(n / base);
    };
    meno.addEventListener('click', function () { if (n > 1) { n--; aggiorna(); } });
    dosi.querySelector('[data-dosi-piu]').addEventListener('click', function () { if (n < 30) { n++; aggiorna(); } });
    aggiorna();
    if (!righe.length) dosi.hidden = true;
  }
  /* vecchi pulsanti ×1/×2/×3 */
  barra.querySelectorAll('[data-dose]').forEach(function (b) {
    b.addEventListener('click', function () {
      scala(Number(b.dataset.dose));
      barra.querySelectorAll('[data-dose]').forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
    });
  });

  /* ---------- Il kit nel carrello ----------
     Ricette col ramen kit ([data-kit]): un kit per persona, quante ne dice il contatore; il gusto è quello scelto.
     Stesso giro della box (assets/noodz-box.js): /cart/add.js con le sezioni del cassetto di Dawn, che si apre. */
  var kit = document.querySelector('[data-kit]');
  if (kit) {
    var bKit = kit.querySelector('[data-kit-aggiungi]');
    var errKit = kit.querySelector('[data-kit-errore]');
    var quanti = function () {
      var o = document.querySelector('[data-dosi-n]');
      return Math.max(1, Number(o ? o.textContent : 1) || 1);
    };
    var etichetta = function () {
      var q = quanti();
      var t = bKit.dataset.testo.replace('[n]', q);
      bKit.textContent = q === 1 ? t.replace(' kits ', ' kit ') : t;
    };
    document.querySelectorAll('[data-dosi-meno], [data-dosi-piu]').forEach(function (b) {
      b.addEventListener('click', etichetta);
    });
    /* la foto della scatola segue il gusto scelto */
    kit.querySelectorAll('input[type="radio"]').forEach(function (r) {
      r.addEventListener('change', function () {
        kit.querySelectorAll('[data-kit-foto]').forEach(function (img) {
          img.classList.toggle('is-nascosta', img.getAttribute('data-kit-foto') !== r.value);
        });
      });
    });
    bKit.addEventListener('click', function () {
      var scelto = kit.querySelector('input[type="radio"]:checked');
      if (!scelto) return;
      var cassetto = document.querySelector('cart-drawer');
      var corpo = { items: [{ id: Number(scelto.value), quantity: quanti() }] };
      if (cassetto) {
        corpo.sections = cassetto.getSectionsToRender().map(function (s) { return s.id; });
        corpo.sections_url = window.location.pathname;
      }
      bKit.disabled = true;
      bKit.setAttribute('aria-busy', 'true');
      errKit.hidden = true;
      fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(corpo)
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok || res.j.status) throw new Error(res.j.description || res.j.message || '');
          bKit.textContent = bKit.dataset.fatto;
          if (cassetto && res.j.sections) {
            cassetto.classList.remove('is-empty');
            cassetto.renderContents(res.j);
          } else {
            window.location.href = (window.routes && window.routes.cart_url) || '/cart';
          }
          setTimeout(etichetta, 2500);
        })
        .catch(function (e) {
          errKit.textContent = bKit.dataset.errore + (e && e.message ? ' (' + e.message + ')' : '');
          errKit.hidden = false;
        })
        .finally(function () {
          bKit.disabled = false;
          bKit.removeAttribute('aria-busy');
        });
    });
  }

  /* ---------- Modalità cucina ---------- */
  var cucina = barra.querySelector('[data-cucina]');
  var blocco = null;
  var voluto = false;
  if (cucina && 'wakeLock' in navigator) {
    cucina.hidden = false;
    var accendi = function () {
      navigator.wakeLock.request('screen').then(function (l) {
        blocco = l;
        l.addEventListener('release', function () { blocco = null; });
      }).catch(function () {
        voluto = false;
        cucina.setAttribute('aria-pressed', 'false');
      });
    };
    cucina.addEventListener('click', function () {
      voluto = !voluto;
      cucina.setAttribute('aria-pressed', String(voluto));
      if (voluto) accendi(); else if (blocco) blocco.release();
    });
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible' && voluto && !blocco) accendi();
    });
  }

  /* ---------- Stampa ---------- */
  document.querySelectorAll('[data-stampa]').forEach(function (b) {
    b.addEventListener('click', function () { window.print(); });
  });
  /* si stampa una copia della scheda messa direttamente nel body: il resto della pagina è nascosto e non lascia
     spazio vuoto (che farebbe una seconda pagina) */
  var copia = null;
  function preparaStampa() {
    var scheda = document.getElementById('Ricetta');
    if (!scheda || copia) return;
    copia = document.createElement('div');
    copia.className = 'ndz-stampa-copia';
    copia.appendChild(scheda.cloneNode(true));
    document.body.appendChild(copia);
    document.documentElement.classList.add('ndz-stampa-ricetta');
  }
  function finisciStampa() {
    if (copia) copia.remove();
    copia = null;
    document.documentElement.classList.remove('ndz-stampa-ricetta');
  }
  document.querySelectorAll('[data-stampa-ricetta]').forEach(function (b) {
    b.addEventListener('click', function () {
      preparaStampa();
      window.print();
    });
  });
  window.addEventListener('afterprint', finisciStampa);
})();
